module.exports = __webpack_public_path__ + "static/media/yellow.f647d957.png";